<template>
<!-- <div> -->
  <button class="btn btn-primary" @click="downloadPDF"><DownloadIcon class="h-3 w-3 mr-1" /> ดาวน์โหลด</button>
  <!-- <img src="./pdf-logo.jpeg"/></div> -->
</template>

<script setup>
import {computed, ref} from "vue"
import pdfMake from 'pdfmake'
import pdfFonts from '@/assets/custom-fonts.js'
import { useStore } from "vuex";
import axios from "axios"
const store = useStore()

const props = defineProps({
  infoData: Object,
});
const getDateTh = (date_param) => {
  if (date_param) {
    const date = new Date(date_param);
    const result = date.toLocaleDateString("th-TH", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return result;
  }
  return "-";
}
const calculateAge = (birthdate) =>{ 
  var diff_ms = Date.now() - birthdate.getTime();
  var age_dt = new Date(diff_ms); 
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}
const calculateAgeComputed = computed(()=>{
  return calculateAge(new Date(props.infoData.birthdate))
})
const getAttendSocactComputed = computed(()=>{
    let result = ""
    if(props.infoData.attend_socact?.length > 0){
        props.infoData.attend_socact.forEach((elm,idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.desc}`
        })
        return result
    }
    return "-"
})
const getSecondaryOccupComputed = computed(()=>{
    let result = ""
    if(props.infoData.secondary_occup?.length > 0){
        props.infoData.secondary_occup.forEach((elm,idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.code == "OC5"? elm.desc +' ('+elm.occu_name+')' : elm.desc}`
        })
        return result
    }
    return "-"
})
const getSavingComputed = computed(()=>{
    let result = [
        {width: '50%', type: 'none',ul:[]},
        {width: '50%', type: 'none',ul:[]}
    ]
    if(props.infoData.saving?.length > 0){
        props.infoData.saving.forEach((elm,idx)=>{
            if(idx%2==0){
                // result[0].ul.push(elm.code == "SV7"? elm.desc +' ('+elm.saving_name+') จำนวน '+elm.amount+' บาท' : `${elm.code == "SV6" ? elm.desc : `${elm.desc} จำนวน ${elm.amount} บาท`}`)
                result[0].ul.push({
                    text:[
                        { text: `${elm.code == "SV7" ? '- '+elm.desc+' ('+elm.saving_name+')' : '- '+elm.desc} `, bold: true,},
                        {text: `${elm.code == "SV6" ? '' : ` ${new Intl.NumberFormat().format(elm.amount)} บาท`}` }
                    ]
                })
            }else{
                // result[1].ul.push(elm.code == "SV7"? elm.desc +' ('+elm.saving_name+') จำนวน '+elm.amount+' บาท' : `${elm.code == "SV6" ? elm.desc : `${elm.desc} จำนวน ${elm.amount} บาท`}`)
                result[1].ul.push({
                    text:[
                        { text: `${elm.code == "SV7" ? '- '+elm.desc+' ('+elm.saving_name+')' : '- '+elm.desc} `, bold: true,},
                        {text: `${elm.code == "SV6" ? '' : ` ${new Intl.NumberFormat().format(elm.amount)} บาท`}` }
                    ]
                })
            }
        })
        return result
    }
    return [
        {text: "-"},
    ]
})
const getExpenditureComputed = computed(()=>{
    let result = [
        {width: '50%', type: 'none',ul:[]},
        {width: '50%', type: 'none',ul:[]}
    ]
    if (props.infoData.expenditure?.length>0){
        props.infoData.expenditure.forEach((elm, idx)=>{
            if(elm.code != "XP12"){
                if(idx%2==0){
                    // result[0].ul.push(`${elm.desc} จำนวน ${elm.amount} บาท`)
                    result[0].ul.push(
                        {
                            text:[
                                { text: `- ${elm.desc}`, bold: true,},
                                {text: ` ${new Intl.NumberFormat().format(elm.amount)} บาท`}
                            ]
                        }
                    )
                }else{
                    result[1].ul.push(
                        {
                            text:[
                                { text: `- ${elm.desc}`, bold: true,},
                                {text: ` ${new Intl.NumberFormat().format(elm.amount)} บาท`}
                            ]
                        }
                    )
                    // result[1].ul.push(`${elm.desc} จำนวน ${elm.amount} บาท`)
                }
            }
        })
    }
    return result
})
const getExpenditureOtherComputed = computed(()=>{
    let result = [
        {width: '50%', type: 'none',ul:[]},
        {width: '50%', type: 'none',ul:[]}
    ]
    if (props.infoData.expenditure?.length>0){
        for (let index = 0; index < props.infoData.expenditure.length; index++) {
            const element = props.infoData.expenditure[index];
            if(element.expenditure_other){
                for(let j = 0; j < element.expenditure_other.length; j++){
                    const exp_other = element.expenditure_other[j]
                    if(j%2==0){
                        result[0].ul.push(
                            {
                                text:[
                                    { text: `- ${exp_other.expenditure_name}`, bold: true,},
                                    {text: ` ${new Intl.NumberFormat().format(exp_other.amount)} บาท`}
                                ]
                            }
                        )
                        // result[0].ul.push(`${exp_other.expenditure_name} จำนวน ${exp_other.amount} บาท`)
                    }else{
                        result[1].ul.push(
                            {
                                text:[
                                    { text: `- ${exp_other.expenditure_name}`, bold: true,},
                                    {text: ` ${new Intl.NumberFormat().format(exp_other.amount)} บาท`}
                                ]
                            }
                        )
                        // result[1].ul.push(`${exp_other.expenditure_name} จำนวน ${exp_other.amount} บาท`)
                    }
                }
                return result
            }
        }
    }
    return [
        {text: "-"},
    ]
})
const getDebtComputed = computed(()=>{
    let result = [
        {width: '50%', type: 'none',ul:[]},
        {width: '50%', type: 'none',ul:[]}
    ]
    if (props.infoData.debt?.length>0){
        props.infoData.debt.forEach((elm, idx)=>{
            if(idx%2==0){
                // result[0].ul.push(`${elm.type} จำนวน ${elm.amount} บาท`)
                result[0].ul.push(
                    {
                        text:[
                            { text: `- ${elm.type}`, bold: true,},
                            {text: ` ${new Intl.NumberFormat().format(elm.amount)} บาท`}
                        ]
                    }
                )
            }else{
                // result[1].ul.push(`${elm.type} จำนวน ${elm.amount} บาท`)
                result[1].ul.push(
                    {
                        text:[
                            { text: `- ${elm.type}`, bold: true,},
                            {text: ` ${new Intl.NumberFormat().format(elm.amount)} บาท`}
                        ]
                    }
                )
            }
        })
        return result
    }
    return [
        {text: "-"},
    ]
})
const getLandAssetComputed = computed(()=>{
    let result = [
        {
            width: '20%',
            text:[
                { text: '- ที่ดิน', bold: true,}
            ]
        },
        {
            width: '30%',
            text:[
                { text: 'อาศัย ', bold: true },
                { text: '-'}
            ]
        },
        {
            width: '50%',
            text:[
                { text: 'เพื่อทำกิน ', bold: true },
                { text: '-'}
            ]
        }
    ]
    if((props.infoData.asset ?? false) && (props.infoData.asset?.land?.length > 0)){
        props.infoData.asset.land.forEach((elm, idx)=>{
            if(elm.type == 'อาศัย'){
                result[1].text[1] = `${new Intl.NumberFormat().format(elm.amount)} ไร่`
            }
            else if(elm.type == 'เพื่อทำกิน'){
                result[2].text[1] = `${new Intl.NumberFormat().format(elm.amount)} ไร่`
            }
        })
    }
    return result
})
const getMachineryAssetComputed = computed(()=>{
    let result = ""
    if((props.infoData.asset ?? false) && (props.infoData.asset?.machinery?.length > 0)){
        props.infoData.asset.machinery.forEach((elm, idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.type} (${new Intl.NumberFormat().format(elm.amount)} เครื่อง)`
        })
        return result
    }
    return "-"
})
const getLivestockAssetComputed = computed(()=>{
    let result = ""
    if((props.infoData.asset ?? false) && (props.infoData.asset?.livestock?.length > 0)){
        props.infoData.asset.livestock.forEach((elm, idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.type} (${new Intl.NumberFormat().format(elm.amount)} ตัว)`
        })
        return result
    }
    return "-"
})
const getBuildingAssetComputed = computed(()=>{
    let result = ""
    if((props.infoData.asset ?? false) && (props.infoData.asset?.building?.length > 0)){
        props.infoData.asset.building.forEach((elm, idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.type} (${new Intl.NumberFormat().format(elm.amount)} หลัง)`
        })
        return result
    }
    return "-"
})
const getGoldAssetComputed = computed(()=>{
    let result = ""
    if((props.infoData.asset ?? false) && props.infoData.asset.gold){
        result = `${props.infoData.asset.gold} บาท`
        return result
    }
    return "-"
})

const getDiseaseComputed = computed(() => {
    let result = ""
    if(props.infoData.chronic_disease?.length > 0){
        props.infoData.chronic_disease.forEach((elm,idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.code == "CD8"? elm.desc +' ('+elm.disease_name+')' : elm.desc}`
        })
        return result
    }
    return ""
});
const getMedSchemeComputed = computed(()=>{
    let result = ""
    if(props.infoData.med_scheme?.length > 0){
        props.infoData.med_scheme.forEach((elm,idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.code == "MS3"? elm.desc +' ('+elm.ofc_owner+')' : elm.desc}`
        })
        return result
    }
    return ""
})
const getIsDisabledComputed = computed(()=>{
  return props.infoData.is_disabled?.valueOf() != undefined ? props.infoData.is_disabled ? 'พิการ' : 'ไม่พิการ' : '-'
})
const getHavePwdCardComputed = computed(()=>{
  return props.infoData.have_pwd_card?.valueOf() != undefined ? props.infoData.have_pwd_card ? 'มีบัตร' : 'ไม่มีบัตร' : '-'
})
const getDisabilityComputed = computed(()=>{
    let result = ""
    if(props.infoData.disability?.length > 0){
        props.infoData.disability.forEach((elm,idx)=>{
            result += `${idx > 0 ? ' / ': ''}${elm.desc}`
        })
        return result
    }
    return "-"
})

const getWelfChildrenYouthComputed = computed(()=>{
  let result = [
    ]
    let resultSubsidy = []
    if(props.infoData.cy_subsidy?.length > 0){
        props.infoData.cy_subsidy.forEach((elm,idx)=>{
            resultSubsidy.push(`${elm.type} จำนวน ${new Intl.NumberFormat().format(elm.amount)} บาท`)
        })
    }
    if(props.infoData.welf_children_youth?.length > 0){
        props.infoData.welf_children_youth.forEach((elm,idx)=>{
            let temp;
            if(elm.code =="WFCY2"){
                temp =  {
                        stack: [
                            `- ${elm.desc}`,
                            {
                                type: 'circle',
                                margin: [20,0,0,0],
                                ul: resultSubsidy
                            }
                        ]
                    }
            }
            else{
                temp = elm.code == "WFCY5" ? `- ${elm.desc} ${props.infoData.cy_education ? '('+props.infoData.cy_education.desc+' '+props.infoData.cy_education.name+')' : ''}` : `- ${elm.desc}`
            }
            result.push(temp)
        })
        return result
    }
    return [
        {text: "-"},
    ]
})

const getWelfFareList = (welfare)=>{
    let result = []
    let spc_code = ""
    if(welfare == "welf_disability"){
        spc_code = "WFDA13"
    }
    else if(welfare == "welf_eldery"){
        spc_code = "WFEL7"

    }
    if(props.infoData[welfare]?.length > 0){
        props.infoData[welfare].forEach((elm,idx)=>{
            result.push(`${elm.code == spc_code ? '- '+elm.desc+' ('+elm.name+')' : '- '+elm.desc} `)
        })
        return result
    }
    return [
        {text: "-"},
    ]
}
const getProblemList = (problem)=>{
    let result = []
    if(props.infoData[problem]?.length > 0){
        props.infoData[problem].forEach((elm,idx)=>{
            result.push(elm.code == "PBOC15"? '- '+elm.desc +' ('+elm.name+')' : '- '+elm.desc)
        })
        return result
    }
    return [
        {text: "-"},
    ]
}
const getProblemSummaryList = (problem)=>{
    let result = [
        // {width: '50%',margin:[0,0,5,0], ul:[]},
        // {width: '50%',margin:[0,0,5,0], ul:[]}
    ]
    if((props.infoData.prob_summary ?? false) && (props.infoData.prob_summary[problem])){
        props.infoData.prob_summary[problem].forEach((elm,idx)=>{
            result.push(elm.code == "PBOC15"? '- '+elm.desc +' ('+elm.name+')' : '- '+elm.desc)
            // if(idx%2==0){
            //    result.push(elm.code == "PBOC15"? elm.desc +' ('+elm.name+')' : elm.desc)
            // }else{
            //     result[1].ul.push(elm.code == "PBOC15"? elm.desc +' ('+elm.name+')' : elm.desc)
            // }
        })
        return result
    }
    return [
        {text: "-"},
    ]
}

const getUserInfo = (uid) =>{
    return new Promise((resolve, reject) => {
        const token = store.getters["userAuth/getToken"];
        const config = {
            url: `${process.env.VUE_APP_BASE_API}user/getUser`,
            method: 'POST',
            headers:{
                Authorization: `Bearer ${token}`,
                "Content-Type": `application/json; charset=utf-8`,
            },
            data: {
                uid: uid
            }
        };
        axios(config)
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        });
    })
}
const getUserInfoResult = async(user)=>{
    let infoResult = await getUserInfo(user)
    return infoResult[0] ? `${infoResult[0].title}${infoResult[0].name} ${infoResult[0].surname}` : "-"

}
const getBase64ImageFromURL= (url) =>{
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/jpeg");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };
    img.src = url;
  });
}
pdfMake.vfs = pdfFonts.pdfMake.vfs
const docDefinition = ref()
const generatingPdf = ref(false)
const imagePdfLogo = require("../../../assets/images/pdf-logo.jpeg")
docDefinition.value = {
  defaultStyle: {
    font: 'THSarabunNew',
    fontSize: 18
  },
  styles: {
    header: {
      fontSize: 22,
      lineHeight: 0.8,
      bold: true
    },
    subHeader:{
      fontSize: 20,
      bold: true
    }
  },
  pageMargins: [ 40, 115, 40, 60 ],
  footer: function(currentPage, pageCount) {
    return {
        fontSize: 14,
        columns:[
            {
                width: "50%",
                text: "ระบบสมุดพกครอบครัวอิเล็กทรอนิกส์",
                alignment: 'left',
                margin:[40,15,0,0]
            },
            {
                width: "50%",
                text: currentPage.toString(),
                alignment: 'right',
                margin:[0,15,40,0]
            }
        ]
    }
  },
}

pdfMake.fonts = {
  // download default Roboto font from cdnjs.com
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  },
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew Italic.ttf',
    bolditalics: 'THSarabunNew BoldItalic.ttf'
  }
}
const downloadPDF = async() =>{
  try{
    generatingPdf.value = true
    let result = props.infoData
    if(result){
      generatingPdf.value = false
      docDefinition.value.header =  {
        image: await getBase64ImageFromURL(imagePdfLogo),
        width: 80,
        alignment: "center",
        margin:[0,20]
    }
      docDefinition.value.content = [
        { text: 'แบบคำขอรับความช่วยเหลือผู้ประสบปัญหาทางสังคม', style: 'header', alignment: 'center' },
        { text: 'กระทรวงการพัฒนาสังคมและความมั่นคงของมนุษย์', style: 'header', alignment: 'center' },
        { text: '1. ข้อมูลทั่วไป', style: 'subHeader', alignment: 'left' , margin: [0, 20, 0, 0] },
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        {
          columns: [
            {
              width: '50%',
              text:[
                { text: 'ชื่อ-นามสกุล ', bold: true},
                { text: `${result.title}${result.name} ${result.surname}`}
              ]
            },
            {
              width: '50%',
              text:[
                { text: 'เลขที่บัตรประชาชน ', bold: true},
                { text: `${result.national_id ? result.national_id : '-'}`}
              ]
            }
          ]
        },
        {
          columns: [
            {
              width: '50%',
              text:[
                { text: 'การเป็นหัวหน้าครัวเรือน ', bold: true},
                { text: `${result.is_hh_head ? 'เป็น' : 'ไม่เป็น'}`}
              ]
            },
            {
              width: '50%',
              text:[
                { text: 'การเป็นหัวหน้าครอบครัว ', bold: true},
                { text: `${result.is_fam_head ? 'เป็น' : 'ไม่เป็น'}`}
              ]
            }
          ]
        },
        {
    	    columns:[
                {
                width: '50%',
                text:[
                    { text: 'วัน/เดือน/ปีเกิด ', bold: true, },
                    {text: getDateTh(result.birthdate)}
                ]
                },
                {
                width: '25%',
                text:[
                    { text: 'อายุ ', bold: true, margin: [20,0,0,0]},
                    {text: calculateAgeComputed},` ปี`
                ]
                },
                {
                width: '25%',
                text:[
                    { text: 'เพศ ', bold: true, margin: [20,0,0,0]},
                    `${result.sex ? result.sex : '-'}`
                ]
                },
            ]
        },
        {
    	    columns:[
                {
                width: '50%',
                text:[
                    { text: 'ศาสนา ', bold: true, },
                    `${result.religion ? result.religion : '-'}`
                ]
                },
                {
                width: '25%',
                text:[
                    { text: 'สัญชาติ ', bold: true, margin: [20,0,0,0]},
                    `${result.national_id ? "ไทย"
                    : result.nationality
                      ? result.nationality == "อื่นๆ"
                        ? result.nationality_other
                          ? result.nationality_other
                          : "-"
                        : "-"
                      : "-"}`
                ]
                },
                {
                width: '25%',
                text:[
                    { text: 'สถานะ ', bold: true, margin: [20,0,0,0]},
                    `${result.vital_status?.valueOf() != undefined
                    ? result.marital_status
                      ? result.marital_status
                      : "เสียชีวิต"
                    : "-"}`
                ]
                },
            ]
        },
        {
          columns: [
            {
              width: '50%',
              text:[
                { text: 'การศึกษา ', bold: true},
                { text: `${result.edu_level
                      ? result.edu_level.desc
                      : "-"}`}
              ]
            },
            {
              width: '50%',
              text:[
                { text: 'สถานะการศึกษา ', bold: true},
                { text: `${result.edu_status
                      ? result.edu_status.desc
                      : "-"}`}
              ]
            },
          ]
        },
        {
        text:[
            { text: 'บ้านเลขที่ ', bold: true},
            `${result.hnum?result.hnum:'-'}`,
            { text: `${result.moo ? ' หมู่ที่ ':''}`, bold: true},
            `${result.moo ? result.moo:''}`,
            { text: `${result.village_name ? ' ชื่อหมู่บ้าน ':''}`, bold: true},
            `${result.village_name?result.village_name: ''}`,
            { text: `${result.soi?' ซอย ': ''}`, bold: true},
            `${result.soi?result.soi: ''}`,
            { text: `${result.road?' ถนน ': ''}`, bold: true},
            `${result.road?result.road: ''}`,
            { text: `${result.tumbol_name?' แขวง/ตำบล ': ''}`, bold: true},
            `${result.tumbol_name?result.tumbol_name: ''}`,
            { text: `${result.amphur_name?' เขต/อำเภอ ': ''}`, bold: true},
            `${result.amphur_name?result.amphur_name: ''}`,
            { text: `${result.province_name?' จังหวัด ': ''}`, bold: true},
            `${result.province_name?result.province_name: ''}`,
            { text: `${result.postcode?' รหัสไปรณษณีย์ ': ''}`, bold: true},
            `${result.postcode?result.postcode:''}`
          ]
        },
        {
        text:[
          { text: 'เบอร์โทรศัพท์ ', bold: true},
            `${result.mobile_num? result.mobile_num: "-"}`
          ]
        },
        {
            columns: [
                {
                    width: '10%',
                    text:[
                        { text: 'บิดา ', bold: true,}
                    ]
                },
                {
                    width: '40%',
                    text:[
                        `${result.father
                            ? `${result.father.title} ${result.father.name} ${result.father.surname}`
                            : "-"}`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'เลขที่บัตรประชาชน ', bold: true,},
                        `${
                            result.father ?
                            result.father.national_id ? result.father.national_id : "-"
                            : "-"
                        }`
                    ]
                }
            ]
        },
        {
            columns: [
                {
                    width: '10%',
                    text:[
                        { text: 'มารดา ', bold: true,}
                    ]
                },
                {
                    width: '40%',
                    text:[
                        `${result.mother
                        ? `${result.mother.title} ${result.mother.name} ${result.mother.surname}`
                        : "-"}`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'เลขที่บัตรประชาชน ', bold: true,},
                        `${result.mother ?
                        result.mother.national_id ? result.mother.national_id : "-"
                        : "-"}`
                    ]
                }
            ]
        },
        /*{
          text: 'ข้อมูลบิดา',bold: true, decoration : 'underline'
        },
        {
            columns: [
                {
                    width: '50%',
                    text:[
                        { text: 'ชื่อ-นามสกุล ', bold: true,},
                        `${result.father
                            ? `${result.father.title} ${result.father.name} ${result.father.surname}`
                            : "-"}`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'สัญชาติ ', bold: true,},
                        `${result.father ?
                        result.father.nationality == "อื่นๆ" ? result.father.nationality_other ? result.father.nationality_other : "-" : result.father.nationality
                        : "-"}`
                    ]
                },
            ]
        },
        {
            columns: [
                {
                    width: '50%',
                    text:[
                        { text: 'เลขบัตรประจำตัวประชาชน ', bold: true,},
                        `${
                            result.father ?
                            result.father.national_id ? result.father.national_id : "-"
                            : "-"
                        }`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'สถานะการมีชีวิต ', bold: true,},
                        `${result.father?
                        result.father.vital_status
                        ? "มีชีวิตอยู่"
                        : "เสียชีวิต"
                        : "-"}`
                    ]
                }
            ]
        },
        {
          text: 'ข้อมูลมารดา',bold: true, decoration : 'underline'
        },
        {
            columns: [
                {
                    width: '50%',
                    text:[
                        { text: 'ชื่อ-นามสกุล ', bold: true,},
                        `${result.mother
                        ? `${result.mother.title} ${result.mother.name} ${result.mother.surname}`
                        : "-"}`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'สัญชาติ ', bold: true,},
                        `${result.mother ?
                        result.mother.nationality == "อื่นๆ" ? result.mother.nationality_other ? result.mother.nationality_other : "-" : result.mother.nationality
                        : "-"}`
                    ]
                },
            ]
        },
        {
            columns: [
                {
                    width: '50%',
                    text:[
                        { text: 'เลขบัตรประจำตัวประชาชน ', bold: true,},
                        `${result.mother ?
                        result.mother.national_id ? result.mother.national_id : "-"
                        : "-"}`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'สถานะการมีชีวิต ', bold: true,},
                        `${result.mother ?
                        result.mother.vital_status
                        ? "มีชีวิตอยู่"
                        : "เสียชีวิต"
                        : "-"}`
                    ]
                }
            ]
        },*/
        // {
        // text:[
        //     { text: 'กิจกรรมที่เข้าร่วม ', bold: true},
        //   ]
        // },
        // {
        //     columns: getAttendSocactComputed
        // },
        {
            text:[
                { text: 'กิจกรรมที่เข้าร่วม ', bold: true,},
                {text: getAttendSocactComputed }
            ]
        },
        { text: '2. อาชีพ/รายได้/รายจ่าย/หนี้สิน/ทรัพย์สิน', style: 'subHeader', alignment: 'left' , margin: [0, 15, 0, 0] },
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        // {
        //   text: 'อาชีพ',bold: true, decoration : 'underline'
        // },
        // {
        //   text: 'อาชีพหลัก',bold: true
        // },
        {
            columns: [
                {
                    width: '50%',
                    text:[
                        { text: 'อาชีพหลัก ', bold: true,},
                        `${result.occup_status ? result.primary_occup.desc == "อื่นๆ" ? result.primary_occup.desc+' ('+result.primary_occup.occu_name+')' : result.primary_occup.desc : '-'}`
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'รายได้เดือนละ ', bold: true,},
                        `${result.occup_status ? new Intl.NumberFormat().format(result.pri_occup_income) : '-'} บาท`
                    ]
                },
            ]
        },
        {
            text:[
                { text: 'อาชีพรอง ', bold: true,},
                {text: getSecondaryOccupComputed }
            ]
        },
        // {
		// 	columns: getSecondaryOccupComputed
		// },
        {
            text:[
                { text: 'รายได้เดือนละ ', bold: true,},
                `${result.secondary_occup?.length > 0 ? new Intl.NumberFormat().format(result.sec_occup_income): '-'} บาท`
            ]
        },
        {
            text:[
                {text: `เงินเก็บต่อเดือน ` , bold: true},
                `${result.SUM_SAVING ?  new Intl.NumberFormat().format(result.SUM_SAVING) : '-'} บาท `
            ]
        },
        {
			columns: getSavingComputed
		},
        {
            text:[
                { text: 'รายจ่ายต่อเดือน ', bold: true,},
                `${result.SUM_EXPENDITURE ?  new Intl.NumberFormat().format(result.SUM_EXPENDITURE) : '-'} บาท`
            ]
        },
        {
			columns: getExpenditureComputed
		},
        {text: 'รายจ่ายอื่นๆ', bold: true},
        {
            columns: getExpenditureOtherComputed
        },
        {
            text:[
                {text: `หนี้สินต่อเดือน ` , bold: true},
                `${result.SUM_DEBT ?  new Intl.NumberFormat().format(result.SUM_DEBT) : '-'} บาท `
            ]
        },
        {
			columns: getDebtComputed
		},
        {
            text: 'ทรัพย์สิน', bold: true
        },
        {
            type: "none",
            ul: [
                {
                    columns: getLandAssetComputed
                },
                {
                    text:[
                        { text: '- ทอง ', bold: true, margin:[0,0,15,0]},
                        { text: getGoldAssetComputed}
                    ]
                },
                {
                    text:[
                        { text: '- สัตว์เศรษฐกิจ ', bold: true, margin:[0,0,15,0]},
                        { text: getLivestockAssetComputed}
                    ]
                },
                {
                    text:[
                        { text: '- สิ่งปลูกสร้าง ', bold: true, margin:[0,0,15,0]},
                        { text: getBuildingAssetComputed}
                    ]
                },
                {
                    text:[
                        { text: '- เครื่องจักร ', bold: true, margin:[0,0,15,0]},
                        { text: getMachineryAssetComputed}
                    ]
                }
            ]
        },
        { text: '3. สุขภาพ', style: 'subHeader', alignment: 'left' , margin: [0, 15, 0, 0] },
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        {
            text:[
                { text: 'โรคประจำตัว ', bold: true, margin:[0,0,15,0]},
                { text: getDiseaseComputed}
            ]
        },
        {
            text:[
                { text: 'สิทธิการรักษาพยาบาล ', bold: true, margin:[0,0,15,0]},
                { text: getMedSchemeComputed}
            ]
        },
        {
			columns: [
                {
                    width: '50%',
                    text:[
                        { text: 'ความพิการ ', bold: true,},
                        {text: getIsDisabledComputed }
                    ]
                },
                {
                    width: '50%',
                    text:[
                        { text: 'มีบัตรประจำตัวคนพิการ ', bold: true,},
                        {text: getHavePwdCardComputed }
                    ]
                },
            ]
		},
        {
            text:[
                { text: 'ประเภทความพิการ ', bold: true, margin:[0,0,15,0]},
                { text: getDisabilityComputed}
            ]
        },
        { text: '4. สวัสดิการ', style: 'subHeader', alignment: 'left' , margin: [0, 15, 0, 0] },
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        {text: 'ด้านเด็กและเยาวชน', bold: true},
        // {
        //     columns: getWelfChildrenYouthComputed
		// },
        {
            type: "none",
			ul: getWelfChildrenYouthComputed
        },
        {text: 'ด้านคนพิการ ', bold: true},
        {
            type: "none",
            ul: getWelfFareList('welf_disability')
			// columns: getWelfDisabilityComputed
		},
        // // {text: `${props.infoData.welf_women?.length > 0 ? 'ด้านสตรี ' : ''}`, bold: true}, //hide main header
        {text: 'ด้านสตรี ', bold: true},
        {
			// columns: getWelfWomenComputed
            type: "none",
            ul: getWelfFareList('welf_women')
		},
        {text: 'ด้านผู้สูงอายุ ', bold: true},
        {
			// columns: getWelfElderyComputed
            type: "none",
            ul: getWelfFareList('welf_eldery')
		},
        {text: 'ด้านคนไร้ที่พึ่ง ', bold: true},
        {
			// columns: getWelfHelplessPersonsComputed
            type: "none",
            ul: getWelfFareList('welf_helpless_persons')
		},
        // // {text: `${props.infoData.welf_others?.length > 0 ? 'ด้านอื่นๆ' : ''}` , bold: true},
        {text: 'ด้านอื่นๆ ', bold: true},
        {
			// columns: getWelfOthersComputed
            type: "none",
            ul: getWelfFareList('welf_others')
		},
        { text: '5. สภาพปัญหาความเดือนร้อนที่พบ', style: 'subHeader', alignment: 'left' , margin: [0, 15, 0, 0] },
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        {text: 'ด้านที่อยู่อาศัย', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_housing')
		},
        {text: 'ด้านสุขภาพอนามัย', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_health')
		},
        {text: 'ด้านการศึกษา', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_education')
		},
        {text: 'ด้านการมีงานทำและมีรายได้', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_occupation')
		},
        {text: 'ด้านครอบครัว', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_family')
		},
        {text: 'ด้านความรุนแรงในครอบครัว/สังคม', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_violence')
		},
        {text: 'ด้านการเป็นผู้เสียหายจากการค้ามนุษย์', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_human_trafficking')
		},
        {text: 'ด้านการเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_accesibility')
		},
        {text: 'ด้านสภาพปัญหาสังคมอื่นๆ', bold: true},
        {
			type: "none",
			ul: getProblemList('prob_others')
		},
        { text: '6. สรุปสภาพปัญหาความเดือนร้อน', style: 'subHeader', alignment: 'left' , margin: [0, 15, 0, 0] },
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        {text: 'มิติสุขภาพ', bold: true},
        {
            type: "none",
			ul: getProblemSummaryList('prob_health')
		},
        {text: 'มิติความเป็นอยู่', bold: true},
        {
			type: "none",
			ul: getProblemSummaryList('prob_family')
		},
        {text: 'มิติการศึกษา', bold: true},
        {
			type: "none",
			ul: getProblemSummaryList('prob_education')
		},
        {text: 'มิติรายได้', bold: true},
        {
			type: "none",
			ul: getProblemSummaryList('prob_occupation')
		},
        {text: 'มิติการเข้าถึงบริการรัฐ', bold: true},
        {
			type: "none",
			ul: getProblemSummaryList('prob_accesibility')
		},
        {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-2*40, y2: 5, lineWidth: 1 }], margin: [0, -6, 0, 20]},
        {
            margin: [20,0,20,0],
            columns:[
                {
                    width: "50%",
                    text:[
                        {text: "Case Manager ", bold: true},
                        {text: `${result.case_manager ? `${result.case_manager.title?result.case_manager.title:""}${result.case_manager.name?result.case_manager.name:"-"} ${result.case_manager.surname?result.case_manager.surname:""}`: '-'}`}
                    ]
                },
                {
                    width: "50%",
                    text:[
                        {text: "อพม. ", bold: true},
                        {text: `${result.volunteer ? `${result.volunteer.title?result.volunteer.title:""}${result.volunteer.name?result.volunteer.name:"-"} ${result.volunteer.surname?result.volunteer.surname :""}`: '-'}`}
                    ]
                }
            ]
        },
        {
            margin: [20,0,20,0],
            columns:[
                {
                    width: "50%",
                    text:[
                        {text: "วันที่จัดทําข้อมูล ", bold: true},
                        {text: getDateTh(result.createdAt)}
                    ]
                },
                {
                    width: "50%",
                    text:[
                        {text: "ผู้จัดทําข้อมูล ", bold: true},
                        {text: `${result.created_by ? await getUserInfoResult(result.created_by.uid) : "-"}`}
                    ]
                }
            ]
        },
        {
            margin: [20,0,20,0],
            columns:[
                {
                    width: "50%",
                    text:[
                        {text: "นําออกข้อมูลโดย ", bold: true},
                        {text: `${store.getters["userAuth/getUsername"] ? await getUserInfoResult(store.getters["userAuth/getUsername"]) : "-"}`}
                    ]
                },
                {
                    width: "50%",
                    text:[
                        {text: "วันที่นําออกข้อมูล ", bold: true},
                        {text: getDateTh(new Date().toISOString())}
                    ]
                }
            ]
        }
        // {text: 'มิติการเข้าถึงบริการรัฐ', bold: true},
        // {
		// 	columns: getProblemSummaryList('prob_accesibility')
		// },
      ]
      pdfMake.createPdf(docDefinition.value).open({}, window.open('', '_blank'))
      // generatingPdf.value = true
    //   pdfMake.createPdf(docDefinition.value).download("userinfo")
    }
  }
  catch(err){
    generatingPdf.value = false
    console.log(err);
  }
}
</script>

<style>

</style>